/* eslint-disable react/jsx-max-depth */
/* eslint-disable max-statements */
import { Card, Carousel, Col, Container, Image, Modal, Row } from "react-bootstrap";
import { useCallback, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";

import DemographicsForm from "../pages/my-account/components/DemographicsForm";
import LwcErrorBoundary from "./LwcErrorBoundary";
import ProfileInfoForm from "../pages/login/registration/ProfileInfoForm";

import loginImage from "../assets/images/login-image.webp";

import { useAuth } from "../services/wp.auth.service";
import { useQueryClient } from "react-query";

import "./ProfileCompleteModal.scss";
import { shouldAttendeeCompleteDemo } from "../helpers/attendeeHelpers";

const carouselItemClasses = "p-3 p-lg-5";

const ProfileCompleteModal = ({
	show
}) => {
	const { user } = useAuth();
	const queryClient = useQueryClient();
	const [currentSlide, setCurrentSlide] = useState(0);

	const demographicsComplete = useMemo(() => !shouldAttendeeCompleteDemo(user), [user]);
	const profileComplete = useMemo(() => user?.attendeeDetails?.profileCompleted, [user]);

	useEffect(() => {
		if (profileComplete) {
			if (demographicsComplete) {
				setCurrentSlide(2);
			} else {
				setCurrentSlide(1);
			}
		}
	}, [user]);

	const nextSlide = useCallback(() => setCurrentSlide((cur) => cur + 1), []);

	const handleFinalSubmit = useCallback(async () => {
		await queryClient.refetchQueries("auth-user");
	}, []);

	return (
		<Modal centered fullscreen show={show}>
			<Modal.Body className="py-3 px-0 p-md-5 bg-neutral10 d-md-flex">
				<Container>
					<Card className="rounded-3" id="complete-profile-card">
						<Row>
							<Col md={8}>
								<Card.Body className="p-0">
									<Carousel
										activeIndex={currentSlide}
										controls={false}
										indicators={false}
										interval={null}
										keyboard={false}
										touch={false}
									>
										<Carousel.Item className={carouselItemClasses}>
											<h1 className="text-neutral6">Complete your <span className="text-primary">Profile</span></h1>
											<LwcErrorBoundary>
												<ProfileInfoForm onSuccess={nextSlide} />
											</LwcErrorBoundary>
										</Carousel.Item>
										<Carousel.Item className={carouselItemClasses}>
											<h1 className="text-neutral6">Complete your <span className="text-primary">Profile</span></h1>
											<LwcErrorBoundary>
												<DemographicsForm onSuccess={handleFinalSubmit} refetchUser={false} />
											</LwcErrorBoundary>
										</Carousel.Item>
									</Carousel>
								</Card.Body>
							</Col>
							<Col className="d-none d-md-block" md={4}>
								<div className="card-popout-image">
									<Image className="rounded-3" src={loginImage} />
								</div>
							</Col>
						</Row>
					</Card>
				</Container>
			</Modal.Body>
		</Modal>
	);
};

ProfileCompleteModal.propTypes = {
	show: PropTypes.bool
};

ProfileCompleteModal.defaultProps = {
	show: false
};

export default ProfileCompleteModal;
